<p>
    Kitty Kat Poker Slots Casino is a full scale android app I was commissioned
    to develop. It's a slot machine game based on matching poker hands with a
    cute cat theme.
</p>

<p>
    We started with a bare bones prototype with hand drawing and a comprehensive
    debug mode. We then moved to final art and audio assets. From there we added
    platform specific items and Google Play API which included:
</p>
<ul>
    <li>
        An account system via Firebase, which supports Google Play, Facebook,
        or email login.
    </li>
    <li>A daily login reward, also using the account system.</li>
    <li>Google Play achievements</li>
    <li>In App Purchases</li>
</ul>
